import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { updateEntry } from 'apps/formsCreationKit/store/actions/sharedActions'
import { lib } from '@gocanvas/client'
const { SINGLE_CHOICE_BOXES_STYLE } = lib

export const ClearAll = ({
  guid,
  style,
  maximum,
  setOptionsType = () => {},
}) => {
  const [showClearAllPrompt, setShowClearAllPrompt] = useState(false)
  const dispatch = useDispatch()

  const clearAll = () => {
    if (style != SINGLE_CHOICE_BOXES_STYLE) {
      dispatch(
        updateEntry({
          guid,
          entry_values: [],
          default: 'GC_BLANK_DEFAULT',
        })
      )
    } else {
      const placeholderOptions = Array.from(
        Array(maximum),
        (element, index) => {
          return {
            placeholder: 'Type your choices here and press Enter',
            position: index,
          }
        }
      )

      dispatch(
        updateEntry({
          guid,
          entry_values: placeholderOptions,
          default: null,
        })
      )
    }
    setShowClearAllPrompt(false)
    setOptionsType(false)
  }

  return showClearAllPrompt ? (
    <>
      <div className="control--label">Are you sure you want to clear?</div>
      <button
        className="gcds--button button--secondary"
        onClick={() => setShowClearAllPrompt(false)}
      >
        <span className="button--label">Cancel</span>
      </button>
      <button
        className={`gcds--button button--primary is-danger button--confirm-clear-all`}
        onClick={clearAll}
      >
        <span className="button--label">Clear</span>
      </button>
    </>
  ) : (
    <>
      <button
        className="gcds--button button--tertiary"
        onClick={() => setShowClearAllPrompt(true)}
      >
        <span className="button--label">Clear all</span>
      </button>
    </>
  )
}
